// ============================================================================
// avecUltimoSync: quando ESTE aparelho sincronizou com o Avec pela última vez
// (A8b do "Dashboard sem zero silencioso", 23/10/2026). Puro.
// ============================================================================
// O problema de antes: fk_avec_last_sync_at era gravada como ISO cru, o upload
// para o cofre falhava sempre no JSON.parse (supabase.js) e o boot aplicava o
// valor congelado do cofre (texto com aspas): new Date('"2026-05-06…"') = NaN,
// então o self-heal ora nunca disparava, ora disparava forçado, por aparelho.
// Agora: chave SÓ do aparelho (fk_avec_sync_aparelho_at, fora das chaves do
// cofre, o loadFromCloud não sobrescreve), leitura tolerante e nada sobe para
// a nuvem (seriam ~2.400 gravações por dia de uma telemetria que ninguém lê).
// ============================================================================

export const CHAVE_SYNC_APARELHO = 'fk_avec_sync_aparelho_at';
export const SELF_HEAL_ATRASO_MIN = 30;

/** Aceita ISO cru, ISO entre aspas (JSON), número e número em texto. ms ou null; nunca NaN. */
export function lerUltimoSyncMs(raw) {
  if (raw === null || raw === undefined) return null;
  let v = raw;
  if (typeof v === 'string') {
    const t = v.trim();
    if (!t) return null;
    try { v = JSON.parse(t); } catch { v = t; }
  }
  if (typeof v === 'number') return Number.isFinite(v) && v > 0 ? v : null;
  if (typeof v === 'string') {
    if (/^\d+$/.test(v)) { const n = Number(v); return n > 0 ? n : null; }
    const ms = Date.parse(v);
    return Number.isFinite(ms) ? ms : null;
  }
  return null;
}

export function valorUltimoSyncParaGravar(ms) {
  return JSON.stringify(Number(ms));
}

/** Sem registro = não está atrasado (o NaN de antes também dava false): sem rajada de sync forçado no 1º boot. */
export function syncAtrasado(ultimoMs, agora = Date.now(), limiteMin = SELF_HEAL_ATRASO_MIN) {
  if (ultimoMs == null) return false;
  return (agora - ultimoMs) / 60000 > limiteMin;
}
